import { GoogleCredentialResponse } from '@react-oauth/google';
import axios from 'axios';
import {useState} from 'react';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


export const GoogleAuth = () => {
    const [authError, setAuthError] = useState<string | null>(null);

    const handleGoogleSignIn = async (credentialResponse: GoogleCredentialResponse) => {
        try {
            console.log("Attempting Auth");


            const subjectToken = credentialResponse.credential;
            if (!subjectToken) {
                throw new Error('Credential token is missing');
            }

            const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/account';
            const response = await axios.get(endpoint, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${subjectToken}`,
                }
            });

            const userData = response.data.value;

            localStorage.setItem('userEmail', userData.email);
            localStorage.setItem('userName', userData.name);
            localStorage.setItem('role', userData.role);

            localStorage.setItem('isSentimentEnabled', userData.subscription?.isSentimentEnabled);
            localStorage.setItem('isTeamsEnabled', userData.subscription?.isTeamsEnabled);
            localStorage.setItem('isOutlookEnabled', userData.subscription?.isOutlookEnabled);
            localStorage.setItem('isWordEnabled', userData.subscription?.isWordEnabled);

            localStorage.setItem('numberOfSeats', userData.numberOfSeats);
            localStorage.setItem('subscriptionType', userData.subscriptionType);
            localStorage.setItem('paid', userData.subscription.paid);
            localStorage.setItem('isChargebeePaid', userData.subscription.chargebeeIsPaid)

            localStorage.setItem('subjectToken', subjectToken);

            const hasPassword = !!userData.password;
            localStorage.setItem('hasPassword', hasPassword.toString());

            return true;
        } catch (error) {
            if (error instanceof Error) {
                console.error("Error during Google authentication:", error.message);
                setAuthError(error.message);
            } else {
                console.error("Unexpected error:", error);
                setAuthError("An unexpected error occurred.");
            }
            return false; // Indicate failure
        }
    };

    const googleAccountLink = async (credentialResponse: GoogleCredentialResponse, linkIdentifier: string | null) => {
        try {
            const subjectToken = credentialResponse.credential;
            const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/account/link?link=' + linkIdentifier;
            const headers: any = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${subjectToken}`,
            };

            if (linkIdentifier) {
                headers['link'] = linkIdentifier;
            }

            const response = await axios.get(endpoint, {
                headers: headers
            });

            const userData = response.data.value;

            localStorage.setItem('userEmail', userData.email);
            localStorage.setItem('userName', userData.name);
            localStorage.setItem('role', userData.role);

            localStorage.setItem('isSentimentEnabled', userData.subscription?.isSentimentEnabled);
            localStorage.setItem('isTeamsEnabled', userData.subscription?.isTeamsEnabled);
            localStorage.setItem('isOutlookEnabled', userData.subscription?.isOutlookEnabled);
            localStorage.setItem('isWordEnabled', userData.subscription?.isWordEnabled);

            localStorage.setItem('cancelled', userData.subscription?.cancelled);


            localStorage.setItem('numberOfSeats', userData.numberOfSeats);
            localStorage.setItem('subscriptionType', userData.subscriptionType);
            localStorage.setItem('paid', userData.subscription.paid);
            localStorage.setItem('googleToken', <string>credentialResponse.credential);

            localStorage.setItem('isChargebeePaid', userData.subscription.chargebeeIsPaid)


            const hasPassword = !!userData.password;
            localStorage.setItem('hasPassword', hasPassword.toString());

            return true;
        } catch (error) {
            if (error instanceof Error) {
                console.error("Error during Google authentication:", error.message);
                setAuthError(error.message);
            } else {
                console.error("Unexpected error:", error);
                setAuthError("An unexpected error occurred.");
            }
            return false; // Indicate failure
        }
    };

    return { handleGoogleSignIn, googleAccountLink, authError };
};
